import React from 'react';

const VehiclePathDisplay = ({ vehiclePaths, locations }) => {
  if (!vehiclePaths || vehiclePaths.length === 0) {
    return null;
  }

  // Format path into a simple arrow-separated list
  const formatPathSequence = (path, locations) => {
    if (!path || !Array.isArray(path) || path.length === 0) {
      return "No path data";
    }
    
    return path.map(point => {
      // Handle different point formats
      const pointId = typeof point === 'string' 
        ? point 
        : (point.id || point);
      
      // Get location name or use ID if not found
      const loc = locations.find(l => l.id === pointId);
      return loc ? (loc.name || pointId) : pointId;
    }).join(" → ");
  };

  return (
    <div className="vehicle-paths-container">
      {vehiclePaths.map((vehicle, index) => (
        <div key={vehicle.id || index} className="vehicle-path-card">
          <div className="vehicle-path-header" style={{background: vehicle.color || '#2196F3'}}>
            <span className="vehicle-number">Vehicle {index + 1}</span>
            <span className="path-distance-value">{vehicle.distance?.toFixed(2) || '0.00'} km</span>
          </div>
          <div className="vehicle-path-sequence">
            {formatPathSequence(vehicle.path, locations)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VehiclePathDisplay; 